import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'authenticator.onboarding.activities.title',
    defaultMessage: 'Confirm your activity',
  },
  leadWithProposal: {
    id: 'authenticator.onboarding.activities.leadWithProposal',
    defaultMessage:
      'Pre-selected from {companyName}. Check it, and correct anything that does not match.',
  },
  leadWithoutProposal: {
    id: 'authenticator.onboarding.activities.leadWithoutProposal',
    defaultMessage:
      'Your answers prepare the configuration of your after-sales service.',
  },
  yourCompany: {
    id: 'authenticator.onboarding.activities.yourCompany',
    defaultMessage: 'your company',
  },
  prefilling: {
    id: 'authenticator.onboarding.activities.prefilling',
    defaultMessage: 'Pre-filling from {companyName}…',
  },
  suggestionFailed: {
    id: 'authenticator.onboarding.activities.suggestionFailed',
    defaultMessage:
      'Your company profile could not be inferred: nothing is pre-selected, answer the questions below.',
  },
  unrelatedActivity: {
    id: 'authenticator.onboarding.activities.unrelatedActivity',
    defaultMessage:
      'Your declared activity does not match an after-sales activity: nothing is pre-selected, answer below.',
  },
  sectorTitle: {
    id: 'authenticator.onboarding.activities.sectorTitle',
    defaultMessage: 'Your business sector',
  },
  domainsTitle: {
    id: 'authenticator.onboarding.activities.domainsTitle',
    defaultMessage: 'Your business domains',
  },
  domainsDescription: {
    id: 'authenticator.onboarding.activities.domainsDescription',
    defaultMessage: 'Several choices possible.',
  },
  volumeTitle: {
    id: 'authenticator.onboarding.activities.volumeTitle',
    defaultMessage: 'Your yearly volume of after-sales cases',
  },
  volumeDescription: {
    id: 'authenticator.onboarding.activities.volumeDescription',
    defaultMessage: 'This figure sizes your offer.',
  },
  customersTitle: {
    id: 'authenticator.onboarding.activities.customersTitle',
    defaultMessage: 'Who are your customers?',
  },
  changedSelection: {
    id: 'authenticator.onboarding.activities.changedSelection',
    defaultMessage:
      'You changed {changes}: the pre-configuration follows your choices.',
  },
  changedSector: {
    id: 'authenticator.onboarding.activities.changedSector',
    defaultMessage: 'the sector',
  },
  changedDomains: {
    id: 'authenticator.onboarding.activities.changedDomains',
    defaultMessage: 'the domains',
  },
  changedVolume: {
    id: 'authenticator.onboarding.activities.changedVolume',
    defaultMessage: 'the volume',
  },
  changedCustomers: {
    id: 'authenticator.onboarding.activities.changedCustomers',
    defaultMessage: 'the customers',
  },
  confirm: {
    id: 'authenticator.onboarding.activities.confirm',
    defaultMessage: 'Confirm',
  },
  retailer: {
    id: 'authenticator.onboarding.customerVertical.retailer',
    defaultMessage: 'Retailer',
  },
  eCommercer: {
    id: 'authenticator.onboarding.customerVertical.eCommercer',
    defaultMessage: 'E-Commerce',
  },
  repairer: {
    id: 'authenticator.onboarding.customerVertical.repairer',
    defaultMessage: 'Repairer',
  },
  manufacturer: {
    id: 'authenticator.onboarding.customerVertical.manufacturer',
    defaultMessage: 'Manufacturer',
  },
  industrial: {
    id: 'authenticator.onboarding.customerVertical.industrial',
    defaultMessage: 'Industrial',
  },
  wholesaler: {
    id: 'authenticator.onboarding.customerVertical.wholesaler',
    defaultMessage: 'Wholesaler',
  },
  highTech: {
    id: 'authenticator.onboarding.domains.highTech',
    defaultMessage: 'High Tech',
  },
  homeAppliances: {
    id: 'authenticator.onboarding.domains.homeAppliances',
    defaultMessage: 'Home Appliances',
  },
  handiwork: {
    id: 'authenticator.onboarding.domains.handiwork',
    defaultMessage: 'Handiwork',
  },
  sport: {
    id: 'authenticator.onboarding.domains.sport',
    defaultMessage: 'Sport',
  },
  mobility: {
    id: 'authenticator.onboarding.domains.mobility',
    defaultMessage: 'Mobility',
  },
  furnishing: {
    id: 'authenticator.onboarding.domains.furnishing',
    defaultMessage: 'Furnishing',
  },
  beauty: {
    id: 'authenticator.onboarding.domains.beauty',
    defaultMessage: 'Beauty',
  },
  mode: {
    id: 'authenticator.onboarding.domains.mode',
    defaultMessage: 'Mode',
  },
  jewelry: {
    id: 'authenticator.onboarding.domains.jewelry',
    defaultMessage: 'Jewelry',
  },
  childcare: {
    id: 'authenticator.onboarding.domains.childcare',
    defaultMessage: 'Childcare',
  },
  games: {
    id: 'authenticator.onboarding.domains.games',
    defaultMessage: 'Games',
  },
  other: {
    id: 'authenticator.onboarding.domains.other',
    defaultMessage: 'Other',
  },
  minReturnVolume: {
    id: 'authenticator.onboarding.returns.minReturnVolume',
    defaultMessage: '0 - 1 000',
  },
  littleReturnVolume: {
    id: 'authenticator.onboarding.returns.littleReturnVolume',
    defaultMessage: '1 000 - 5 000',
  },
  mediumReturnVolume: {
    id: 'authenticator.onboarding.returns.mediumReturnVolume',
    defaultMessage: '5 000 - 10 000',
  },
  highReturnVolume: {
    id: 'authenticator.onboarding.returns.highReturnVolume',
    defaultMessage: '10 000 - 100 000',
  },
  maxReturnVolume: {
    id: 'authenticator.onboarding.returns.maxReturnVolume',
    defaultMessage: '+ of 100 000',
  },
  enterprises: {
    id: 'authenticator.onboarding.returns.enterprises',
    defaultMessage: 'Enterprises',
  },
  private: {
    id: 'authenticator.onboarding.returns.private',
    defaultMessage: 'Private',
  },
  both: {
    id: 'authenticator.onboarding.returns.both',
    defaultMessage: 'Both',
  },
});
